type YardData = {
  showBannerText: boolean
  yardSections: YardSection[]
}

type YardSection = {
  headerIcon: string
  headerText: string
  itemKey: string
  itemValue: string
  itemKeySpan: string
  edocsUrl: string
  documentUrl: string
  isButtonVisible: boolean
  isButtonEnabled: boolean
  buttonText: string
  showUnavailableText: boolean
  unavailabletext: string
  footerText: string
  isCompleted: boolean
}

const getDefaultYardSection = () => {
  let output: YardSection = {
    headerIcon: "",
    headerText: "",
    itemKey: "",
    itemValue: "",
    itemKeySpan: "",
    edocsUrl: "",
    documentUrl: "",
    isButtonVisible: false,
    isButtonEnabled: false,
    buttonText: "",
    showUnavailableText: false,
    unavailabletext: "",
    footerText: "",
    isCompleted: false
  }

  return output
}

export const getYardData = (yardData: any, edocsData: any) => {
  let output: any = {}
  let inboundSection: any = {}
  let outboundSection: any = {}
  let yardInbound: any = yardData?.inbound
  let yardOutbound: any = yardData?.outbound
  let eDocsInbound: any = edocsData?.inbound
  let eDocsOutbound: any = edocsData?.outbound

  output.showBannerText = eDocsInbound != null || eDocsOutbound != null

  inboundSection = getYardSectionData("Inbound", yardInbound, eDocsInbound)

  outboundSection = getYardSectionData("Outbound", yardOutbound, eDocsOutbound)
  if (
    inboundSection != null &&
    outboundSection != null &&
    inboundSection.isButtonEnabled &&
    !inboundSection.buttonText.includes("View") &&
    outboundSection.isButtonVisible
  ) {
    outboundSection.isButtonEnabled = false
    outboundSection.footerText = "Waiting for IB completion"
  }
  output.yardSections = [inboundSection, outboundSection].filter(
    x => x !== null
  )

  return output
}

const getYardSectionData = (
  direction: string,
  yardData: any,
  edocsData: any
) => {
  if (yardData == null) {
    return null
  }

  let output: YardSection = getDefaultYardSection()
  output.headerIcon =
    direction == "Inbound" ? "arrowDownRight" : "arrowTopRight"
  output.headerText = direction

  output.itemKey = "Load #"
  output.itemValue = yardData.loadNumber
  output.itemKeySpan = "No documentation required"
  output.isButtonVisible = true
  output.isButtonEnabled = true

  let buttonText: string =
    direction == "Inbound" ? "Mark IB as Complete" : "Mark OB as Complete"

  if (edocsData != null) {
    output.itemKeySpan = ""
    if (edocsData.status == "not-available") {
      output.isButtonVisible = false
      output.isButtonEnabled = false
      buttonText = ""
      output.showUnavailableText = true
      output.unavailabletext =
        direction == "Inbound" ? "No POP available" : "No BOL available"
    } else {
      output.edocsUrl = edocsData.url
      output.documentUrl = edocsData.documentUrl
      buttonText = getButtonText(edocsData?.status, direction)
    }
  }
  output.isCompleted = edocsData?.status == "completed" ? true : false
  output.buttonText = buttonText
  return output
}

const getButtonText = (status: string, direction: string) => {
  let out: string = ""
  switch (status) {
    case "initiated":
      out = "Awaiting Approval"
      break
    case "completed":
      out = direction == "Inbound" ? "View ePOD" : "View ePOP"
      break
    case "not-initiated":
      out = direction == "Inbound" ? "Initiate ePOD" : "Initiate eBOL"
      break
    default:
      out = ""
  }
  return out
}
